module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-246.636bbdbd.jpg";